module.exports = __webpack_public_path__ + "static/img/kexue.74c31d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/kexue.png
// module id = KpEF
// module chunks = 2